import { render, staticRenderFns } from "./RecipeFoodstuffForm.vue?vue&type=template&id=cad48e7a&scoped=true"
import script from "./RecipeFoodstuffForm.vue?vue&type=script&lang=js"
export * from "./RecipeFoodstuffForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeFoodstuffForm.vue?vue&type=style&index=0&id=cad48e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad48e7a",
  null
  
)

export default component.exports